module.exports = __webpack_public_path__ + "static/media/upgradeIcon.b62a89bd.svg";